<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Gift Stocks' : 'Deleted Gift'"
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  :to="`gift-stocks/create`"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start" style="min-width: none">
                        Store Name
                      </th>
                      <th class="text-start" style="min-width: none">
                        Gift Name
                      </th>
                      <th class="text-start" style="min-width: none">
                        Quantity
                      </th>
                      <th class="text-start" style="min-width: none">Date</th>
                      <th class="text-start" style="min-width: none">Remarks</th>
                      <th class="text-start" style="min-width: none">Approval Status</th>
                    </tr>
                  </thead>
                  <tbody v-if="gift_stocks.length != 0">
                    <tr
                      v-for="(gift_stock, i) in gift_stocks"
                      :key="`gift_stock_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': gift_stocks.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="gift_stock.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Gift Stock is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="gift_stock.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Gift Stock is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          gift_stock.store ? gift_stock.store.business_name : ""
                        }}
                      </td>
                      <td>
                        {{
                          gift_stock.store_gift.gift
                            ? gift_stock.store_gift.gift.name
                            : ""
                        }}
                      </td>
                      <td>
                        <span 
                          :class="gift_stock.quantity >= 0 ? 'quantity-positive' : 'quantity-negative'"
                          style="font-weight: 600;"
                        >
                          {{ gift_stock.quantity >= 0 ? '+' : '' }}{{ gift_stock.quantity }}
                        </span>
                      </td>
                      <td>
                        {{
                          gift_stock.date
                            ? gift_stock.date
                            : new Date(gift_stock.created_at)
                                .toISOString()
                                .split("T")[0] || ""
                        }}
                      </td>
                      <td>
                        <div v-if="gift_stock.remarks" class="remarks-cell">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span 
                                v-bind="attrs" 
                                v-on="on"
                              >
                                {{ gift_stock.remarks | truncate(25) }}
                              </span>
                            </template>
                            <span>{{ gift_stock.remarks }}</span>
                          </v-tooltip>
                        </div>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <v-chip
                          :color="gift_stock.is_used == 1 ? 'success' : 'warning'"
                          :text-color="'white'"
                          small
                        >
                          {{ gift_stock.is_used == 1 ? "APPROVED" : "PENDING" }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_gift_stock" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Product Stock deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_gift_stock = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_gift_stock" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift Stock restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_gift_stock = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "StoreGiftStocksPage",
  filters: {
    truncate(text, length = 30) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    }
  },
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
      },
      gift_stocks: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportModuleTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_gift_stock: false,
      is_deleted_gift_stock: false,
      is_restored_gift_stock: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      console.log(
        "this.$route.params.storeGiftId ==>",
        this.$route.params.storeGiftId
      );
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      // this.filter.store_id = this.decryptIt(this.$route.params.storeId);
      this.filter.store_gift_id = this.decryptIt(
        this.$route.params.storeGiftId
      );
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&store_gift_id=" +
        this.filter.store_gift_id +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`gift_stocks?${query}`)
        .then((response) => {
          this.gift_stocks = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(this.filter);
          console.log(error);

          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    // async generateExcel() {
    //   let query = "search_keyword=" + this.filter.search_keyword;
    //   let response = await axios.get(`gift_stock_exports?${query}`);
    //   console.log(response.data.data);
    //   if (response) {
    //     window.open(`${response.data.data}`, "_blank");
    //   }
    // },
    async Delete_this(id) {
      this.delete_gift_stock = true;
      await axios
        .post(`/gift_stocks/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_gift_stock = false;
          this.is_deleted_gift_stock = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_gift_stock = true;
      await axios
        .post(`/gift_stocks/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_gift_stock = false;
          this.is_restored_gift_stock = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        });
      } catch (error) {
        return 'Invalid Date';
      }
    },
  },
};
</script>

<style scoped>
/* Quantity styling */
.quantity-positive {
  color: #2e7d32;
}

.quantity-negative {
  color: #c62828;
}

/* Remarks styling */
.remarks-cell {
  max-width: 200px;
}
</style>
